const member = resolve =>
  require(["@/components/member/member/index.vue"], resolve);
const memberDetail = resolve =>
  require(["@/components/member/member/memberDetail.vue"], resolve);
export default [
  {
    path: "/homeMain/member/member",
    component: member,
  },
  {
    path: "/homeMain/member/memberDetail",
    component: memberDetail
  }
];



// WEBPACK FOOTER //
// ./src/router/members.js